import React from 'react';

export default function MainContent({children}) {
	return <section className='container page-content'>
		<hr className='vertical-space3'/>
		{children}
		<div className='white-space'/>
	</section>
}
